module.exports = __webpack_public_path__ + "img/image-landscape.50cf468b.svg";